/** Tracker-qualified campaign tag overrides; TC stays behind automation capability.
 * For Media Devoted | Created By Ciro Autiero */

import { matchTracker, trackerCan, type TagTrafficProvider, type TrackerId } from '@trafficpulse/shared';

export function tagProviderOf(id: TrackerId): TagTrafficProvider | undefined {
  return matchTracker<TagTrafficProvider | undefined>(id, {
    voluum: () => 'VOLUUM',
    binom: () => 'BINOM',
    'tres-commas': () => trackerCan(id, 'automationGates') ? 'TRES_COMMAS' : undefined,
  });
}
